// components/PdfLayout.js
import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

const PdfLayout = ({ children, data }) => {
  return (
      <Box
          sx={{
              width: '794px', // A4 width in px
              height: '1123px', // A4 height in px
              padding: 0,
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
          }}
      >
          {/* Header */}
          <Box>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box sx={{ width: "150px", height: "150px" }} component="img" src="/assets/images/X_RealX.png" />
                  <Typography variant="h5">RealX Marketplace Private Limited</Typography>
                  <Box sx={{ width: "50px", height: "50px", mr: 1 }} component="img" src="/assets/images/realx_sq_logo.png" />
              </Stack>
              <Divider sx={{ borderBottomWidth: 1, bgcolor: 'black !important', width: '80%', margin: '0px auto' }} />


              {/* Main content */}
              <Box sx={{ p: 4, fontFamily: 'Arial, sans-serif', backgroundColor: '#fff' }}>
                  {children}
              </Box>

          </Box>

          {/* Footer */}
          <Box sx={{ textAlign: 'center',mb:2 }}>
              <Divider />
              <Typography variant="body2">
                  303, Olympia Business House, Sr. No. 36/1, Baner, Pune, Maharashtra 411021
              </Typography>
          </Box>
      </Box>
  );
};

export default PdfLayout;
